export default "/build/64a348b1da4e2dee.png"